import { VChip, VCol } from "vuetify/lib";

export default {
	name: "ReportChips",

	inheritAttrs: false,

	props: {
		filters: {
			required: true,
			type: Array,
			validator: filters =>
				filters.every( filter =>
					typeof filter === "object"
						&& filter.hasOwnProperty( "name" )
						&& filter.hasOwnProperty( "value" )
				)
		}
	},

	render() {
		return <VCol attrs={this.$attrs}>
			{this.filters.map( filter =>
				<VChip
					class="my-1 mr-2"
					color="white"
					label
					outlined
				>{filter.name}: {filter.value}</VChip>
			)}
		</VCol>;
	}
};
